import { useState } from "react";
import InfoIcon from "../../../assets/svg/InfoIcon";
import AddIcon from "../../../assets/svg/AddIcon";
import { ICelebrateComingSoon } from "./ICelebrateComingSoon";
import { ICelebrateModal } from "./ICelebrateModal";
export const ICelebrate = () => {
  const [iCelebrateInfo, setICelebrateInfo] = useState(false);
  const [comingSoon, setComingSoon] = useState(false);

  return (
    <div>
      <div className="py-4 flex justify-between items-center">
        <button
          onClick={() => {
            setICelebrateInfo(true);
          }}
          className="flex space-x-2"
        >
          <p className="text-base font-semibold">iCelebrate</p>
          <InfoIcon />
        </button>

        <button
          onClick={() => {
            setComingSoon(true);
          }}
          className="flex items-center space-x-1"
        >
          <span
            className="text-sm font-semibold text-primary-500"
            style={{ fontSize: "14px" }}
          >
            Add
          </span>
          <AddIcon />
        </button>
      </div>

      <div>
        <p className="text-sm text-gray-600">
          No iCelebrate post yet. What are you looking for right now?
        </p>
      </div>
      {comingSoon && (
        <ICelebrateComingSoon handleClose={() => setComingSoon(false)} />
      )}
      {iCelebrateInfo && (
        <ICelebrateModal handleClose={() => setICelebrateInfo(false)} />
      )}
    </div>
  );
};
